module.exports = require('./readable').Transform



// WEBPACK FOOTER //
// ./~/stream-browserify/~/readable-stream/transform.js